"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridColumnShownStatePlugin = void 0;
const react_1 = __importDefault(require("react"));
const GridColumnMenu_1 = require("./components/GridColumnMenu/GridColumnMenu");
const emptyColumnsContentRenderer_1 = require("./renderers/emptyColumnsContentRenderer");
function gridColumnShownStatePlugin(config) {
    return ({ getColumns }) => {
        return {
            bodyAddons: (original) => {
                if (getColumns().filter((i) => !i.isService).length) {
                    return original;
                }
                return [
                    {
                        id: 'notHaveColumns',
                        render: () => {
                            if (getColumns().filter((i) => !i.isService).length) {
                                return react_1.default.createElement(react_1.default.Fragment, {
                                    key: 'notHaveColumns'
                                });
                            }
                            return (0, emptyColumnsContentRenderer_1.emptyColumnsContentRenderer)();
                        }
                    }
                ];
            },
            containerAddons: [
                {
                    id: 'column-menu',
                    order: 0,
                    render: () => {
                        return react_1.default.createElement(GridColumnMenu_1.GridColumnMenu, {
                            items: config.menu
                        });
                    }
                }
            ],
            processColumns: (columns) => {
                const menuIDs = config.menu.map((i) => i.id);
                const shownIDs = config.menu.filter((i) => i.value).map((i) => i.id);
                return [...columns].filter((i) => {
                    return !menuIDs.includes(i.id) || shownIDs.includes(i.id);
                });
            }
        };
    };
}
exports.gridColumnShownStatePlugin = gridColumnShownStatePlugin;
//# sourceMappingURL=gridColumnShownStatePlugin.js.map